import { unsafeCSS, css } from 'lit';
import styles from './radioOptionButton.scss?inline';
import SotbitRadioOption from '../radioOption';

export default class SotbitRadioOptionButton extends SotbitRadioOption {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = SotbitRadioOption.properties;
}
